import Vue from 'vue'
import Router from 'vue-router'
const home = r => require.ensure([], () => r(require('../pages/home')), 'el-home')
const firmOffer = r => require.ensure([], () => r(require('../pages/firmOffer')), 'el-firmOffer')
const joinSpds = r => require.ensure([], () => r(require('../pages/spds/join')), 'el-joinSpds')
const loginPage = r => require.ensure([], () => r(require('../pages/loginPage')), 'el-login')
const configure = r => require.ensure([], () => r(require('../pages/configure')), 'el-configure')
const memberInfo = r => require.ensure([], () => r(require('../pages/spds/memberInfo')), 'el-memberInfo')
const newsList = r => require.ensure([], () => r(require('../pages/spds/newsList')), 'el-newsPage')
const newsPage = r => require.ensure([], () => r(require('../pages/spds/newsPage')), 'el-newsPage')
const basic = r => require.ensure([], () => r(require('../pages/basic/basic')), 'el-basic')
const allApply = r => require.ensure([], () => r(require('../pages/basic/allApply')), 'el-basic')
const info = r => require.ensure([], () => r(require('../pages/basic/info')), 'el-basic')
const phone = r => require.ensure([], () => r(require('../pages/basic/phone')), 'el-basic')
const quit = r => require.ensure([], () => r(require('../pages/basic/quit')), 'el-basic')
const permission = r => require.ensure([], () => r(require('../pages/basic/permission')), 'el-basic')
const historylData = r => require.ensure([], () => r(require('../pages/spds/historylData')), 'el-history')
Vue.use(Router)
export default new Router({
  mode: 'history',
  base: __dirname,
  routes: [
    {
      name: 'home',
      path: '/',
      component: home,
      redirect: '/firmOffer',
      meta: {
        title: '实盘交易大赛'
      },
      children: [
        {
          name: 'firmOffer',
          path: '/firmOffer',
          component: firmOffer,
          meta: {
            title: '实盘交易大赛'
          }
        },
        {
          name: 'joinSpds',
          path: '/joinSpds',
          component: joinSpds,
          meta: {
            title: '报名实盘交易大赛',
            requiresAuth: true
          }
        },
        {
          name: 'historylData',
          path: '/historylData',
          component: historylData,
          meta: {
            title: '历史用户数据录入',
            requiresAuth: true
          }
        },
        {
          name: 'basic',
          path: '/basic',
          component: basic,
          redirect: '/basic/allApply',
          meta: {
            requiresAuth: true
          },
          children: [
            {
              name: 'info',
              path: 'info',
              component: info
            },
            {
              path: 'allApply',
              component: allApply
            },
            {
              path: 'phone',
              component: phone
            },
            {
              name: 'quit',
              path: 'quit',
              component: quit
            },
            {
              path: 'permission',
              component: permission
            }
          ]
        },
        {
          name: 'memberInfo',
          path: '/memberInfo',
          component: memberInfo,
          meta: {
            title: '用户信息'
          }
        },
        {
          name: 'newsList',
          path: '/newsList',
          component: newsList,
          meta: {
            title: '新闻列表'
          }
        },
        {
          name: 'newsPage',
          path: '/newsPage',
          component: newsPage,
          meta: {
            title: '新闻中心'
          }
        },
        {
          name: 'loginPage',
          path: '/loginPage',
          component: loginPage,
          meta: {
            title: '登录'
          }
        },
        {
          name: 'configure',
          path: '/configure',
          component: configure,
          meta: {
            title: '模型配置'
          }
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js